import { useAgentsQuery } from 'hooks/useAgentsQuery'
import { Media } from 'media'
import { ComponentType } from 'react'
import { RentsDesktop } from './rents-desktop'
import { RentsMobile } from './rents-mobile'

export const Rents: ComponentType = () => {
  const { data } = useAgentsQuery({
    variables: { query: { team: 'rents' } },
  })

  return (
    <>
      <Media at="xs">
        <RentsMobile agents={data?.agents.data ?? []} />
      </Media>
      <Media greaterThan="xs">
        <RentsDesktop agents={data?.agents.data ?? []} />
      </Media>
    </>
  )
}
